import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ActionCreators from '../actions';
import FormResponse from '../components/LeadEngageV2';

function mapDispatchToProps(dispatch) {
  return bindActionCreators(ActionCreators, dispatch);
}

function mapStateToProps(state) {
  return {
    formresponse: state.Formresponse,
    business: state.business,
    auth: state.auth,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(FormResponse);
